import { Box, Button, Typography } from "@mui/material";
import {
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import { LanguageContext } from "../../../globals/LanguageContext";
import { StyledInvoiceCard } from "./invoiceCard.styled";
import { ArrowsOut, Plus } from "@phosphor-icons/react";
import { AddInvoiceForm } from "../../form/AddInvoiceForm";
import { InvoiceListItem } from "../../invoiceList/InvoiceListItem/invoiceListItem";
import { Invoice } from "../../../models/Invoice";
import { InvoiceFilterBar } from "../../invoiceList/invoiceListHeader/invoiceListHeader";
import { InvoiceList } from "../../invoiceList/invoiceList";

type InvoiceCardProps = {
  onClick: (component: ReactNode) => void;
  invoices: Invoice[];
  onSelect: (invoice: Invoice) => void;
};

export const InvoiceCard = ({
  onClick,
  invoices,
  onSelect,
}: InvoiceCardProps) => {
  const { dictionary } = useContext(LanguageContext);
  const [opened, setopened] = useState<boolean>(false);

  return (
    <StyledInvoiceCard opened={opened}>
      <Box className="head">
        <Typography variant="h3">
          {dictionary.pages.projects.project.invoice.title}
        </Typography>
        <Box>
          <ArrowsOut
            size={32}
            weight="bold"
            className="button"
            onClick={() => setopened(!opened)}
          />
        </Box>
      </Box>
      <InvoiceList
        invoices={invoices}
        fullScreen={opened}
        onSelect={onSelect}
      />
    </StyledInvoiceCard>
  );
};
